// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3KCDb","col":"styles_col__2QS94"};